import { render, staticRenderFns } from "./RegistrationNavigationDrawer.vue?vue&type=template&id=2c3b418d&scoped=true&"
import script from "./RegistrationNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./RegistrationNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNavigationDrawer.vue?vue&type=style&index=0&id=2c3b418d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b418d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VImg,VNavigationDrawer})
